import { clickType } from "@/types/generalTypes";
import React from "react";

function FilterIcon({ className, onClick }: clickType) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      className={className}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.500002 0C0.312708 0 0.14112 0.104674 0.055418 0.271209C-0.0302842 0.437745 -0.0157272 0.638212 0.0931351 0.790619L5 7.66023V13.5C5 13.6844 5.10149 13.8538 5.26407 13.9408C5.42665 14.0278 5.62392 14.0183 5.77735 13.916L8.77735 11.916C8.91645 11.8233 9 11.6672 9 11.5V7.66023L13.9069 0.790619C14.0157 0.638212 14.0303 0.437745 13.9446 0.271209C13.8589 0.104674 13.6873 0 13.5 0H0.500002Z"
        fill="#374957"
      />
    </svg>
  );
}

export default FilterIcon;
